import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20.572 20.447"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#1d1d1d",
      d: "M20.571 10.285A10.286 10.286 0 1 0 8.678 20.447v-7.188H6.065v-2.974h2.613V8.019a3.629 3.629 0 0 1 3.885-4 15.83 15.83 0 0 1 2.3.2v2.53h-1.3a1.487 1.487 0 0 0-1.676 1.606v1.931h2.853l-.456 2.973h-2.4v7.188a10.29 10.29 0 0 0 8.687-10.162Z",
      "data-name": "Icon fa-brands-facebook"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "share-facebook"}) } }